module.exports = __webpack_public_path__ + "img/gm.ab02d5bb.jpg";